import data from './horaTranslations.json';
import { normalizeLanguage } from './languages';

export type HoraPlanet = 'Sun' | 'Moon' | 'Mars' | 'Mercury' | 'Jupiter' | 'Venus' | 'Saturn';
export type HoraProfile = { name: string; quality: string; nature: string; activities: string; caution: string };
type HoraCopy = { ui: typeof data.en.ui; planets: Record<HoraPlanet, HoraProfile> };
export function horaCopy(language?: string): HoraCopy {
  return data[normalizeLanguage(language)];
}
export function horaProfile(planet: string, language?: string): HoraProfile | null {
  const profiles = horaCopy(language).planets;
  return Object.prototype.hasOwnProperty.call(profiles, planet) ? profiles[planet as HoraPlanet] : null;
}
// Summaries are original editorial wording of traditional associations, not predictions.

export function horaTime(value: string, timezone: string, language?: string, selectedDate?: string): string {
  const normalized = normalizeLanguage(language);
  const locale = `${normalized}-IN`;
  const time = new Date(value);
  const parts = new Intl.DateTimeFormat('en-CA', { timeZone: timezone, year: 'numeric', month: '2-digit', day: '2-digit' }).formatToParts(time);
  const part = (type: string) => parts.find(item => item.type === type)?.value;
  const localDate = `${part('year')}-${part('month')}-${part('day')}`;
  return new Intl.DateTimeFormat(locale, {
    timeZone: timezone, hour: '2-digit', minute: '2-digit', hour12: true,
    ...(selectedDate && localDate !== selectedDate ? { day: 'numeric', month: 'short' as const } : {}),
  }).format(time);
}

const HORA_COLORS: Record<HoraPlanet, { light: string; dark: string; lightBackground: string; darkBackground: string }> = {
  Sun: { light: '#9a3412', dark: '#fdba74', lightBackground: '#fff7ed', darkBackground: '#431407' },
  Moon: { light: '#1d4ed8', dark: '#93c5fd', lightBackground: '#eff6ff', darkBackground: '#172554' },
  Mars: { light: '#b91c1c', dark: '#fca5a5', lightBackground: '#fef2f2', darkBackground: '#450a0a' },
  Mercury: { light: '#166534', dark: '#86efac', lightBackground: '#f0fdf4', darkBackground: '#052e16' },
  Jupiter: { light: '#854d0e', dark: '#fde047', lightBackground: '#fefce8', darkBackground: '#422006' },
  Venus: { light: '#9d174d', dark: '#f9a8d4', lightBackground: '#fdf2f8', darkBackground: '#500724' },
  Saturn: { light: '#475569', dark: '#cbd5e1', lightBackground: '#f1f5f9', darkBackground: '#0f172a' },
};
export function horaAppearance(planet: string, dark = false) {
  const palette = Object.prototype.hasOwnProperty.call(HORA_COLORS, planet) ? HORA_COLORS[planet as HoraPlanet] : HORA_COLORS.Saturn;
  return { color: dark ? palette.dark : palette.light, background: dark ? palette.darkBackground : palette.lightBackground };
}
